import React from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import Hero from '../components/Hero';
import Slider from '../components/Slider';
import SEO from '../components/SEO';

import starSVG from '../static/svgs/star.svg';

const SiteData = {
  title: 'Strona Główna',
  slug: '/',
  description:
    'LUK & LUK Auto Serwis to Niezależny Serwis BMW. Jego siedziba znajduje się w Raciborzu, województwie śląskim od 2003 roku. Jako niezależny serwis BMW świadczymy bardzo szeroki zakres usług. Począwszy od okresowych przeglądów, wymiany opon i mechaniki, po kodowanie, zaawansowaną diagnostykę i naprawy powypadkowe.',
};

const IndexPage = ({ data }) => {
  const { edges } = data.allServicesDataJson;
  return (
    <div>
      <SEO isSeo siteData={SiteData} type="Local Business" />
      <Hero image={data.hero_background.sizes} heading="Profesjonalny serwis pojazdów marki BMW">
        <div className=" margin-top-67 padding-bottom-20">
          <Link to="/kontakt" className="more">
            <span>Skontaktuj się</span>
          </Link>
        </div>
      </Hero>
      <div className="row page-margin-top-section">
        <div className="row">
          <h2 className="box-header">Dlaczego Luk & Luk?</h2>
          <p className="description align-center">
            Jesteśmy serwisem z 15 letnim doświadczeniem, cieszymy się uznaniem wśród wielbicieli marki jako niezależny
            serwis BMW o dużych i nie ograniczonych możliwościach.
          </p>
          <div className="row page-margin-top">
            <div className="column column-1-3">
              <ul className="features-list big">
                <li>
                  <div className="hexagon">
                    <div className="sl-small-team" />
                  </div>
                  <h4 className="box-header page-margin-top">Rozumiemy Cię</h4>
                  <p>
                    Wiemy jak ważne dla Ciebie jest Twoje BMW, bo sami jesteśmy właścicielami pojazdów tej firmy, <br />
                    dlatego do każdej naprawy podchodzimy tak, jakbyśmy naprawiali swój samochód.
                  </p>
                </li>
              </ul>
            </div>
            <div className="column column-1-3">
              <ul className="features-list big">
                <li>
                  <div className="hexagon">
                    <div className="sl-small-engine-belt" />
                  </div>
                  <h4 className="box-header page-margin-top">Jakość części na miarę BMW</h4>
                  <p>
                    Jesteśmy certyfikowanym dystrybutorem oryginalnych części ASO BMW Bawaria Motors. <br />
                    Oddając nam samochód nie martwisz się o niską jakość montowanych w Twoim BMW podzespołów.
                  </p>
                </li>
              </ul>
            </div>
            <div className="column column-1-3">
              <ul className="features-list big">
                <li>
                  <div className="hexagon">
                    <div className="sl-small-certificate" />
                  </div>
                  <h4 className="box-header page-margin-top">Certyfikowane standardy usług</h4>
                  <p>
                    Posiadamy dziesiątki certyfikatów potwierdzające wysokie standardy naszych usług. Mimo wszystko,{' '}
                    <br />
                    najlepszymi świadectwami o naszej jakości są opinie wystawione przez naszych klientów 🙂
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="align-center margin-top-67 padding-bottom-20">
            <Link to="/uslugi" className="more">
              <span>poznaj naszą ofertę</span>
            </Link>
          </div>
        </div>
      </div>

      <div className="row full-width gray flex-box page-margin-top-section">
        <div className="column column-1-2">
          <Img
            sizes={data.bossImage.sizes}
            style={{ height: '100%' }}
            imgStyle={{ width: 'auto', height: '100%' }}
            outerWrapperClassName="indexOwnerImage"
          />
        </div>
        <div className="column column-1-2 padding-bottom-66 flex-center">
          <div className="row padding-left-right-100 ">
            <h2 className="box-header page-margin-top-section">Jak powstał serwis BMW Luk & Luk?</h2>
            <p className="description align-center">
              "W związku z długotrwałym zamiłowaniem do marki z Bawarii i ogromem doświadczeń w naprawach tych
              samochodów na własną rękę, postanowiliśmy w 2003 roku oficjalnie założyć serwis samochodowy skupiający się
              wyłącznie na naprawach aut marki BMW, bo znaliśmy je od podszewki. Nasz zespół stara się zadowolić klienta
              oferując mu najszerszy zakres usług jaki tylko jest możliwy. Staramy się na bieżąco podnosić nasze
              kwalifikacje i nie zostawać w tyle z nowinkami technicznymi jakie serwuje nam producent pojazdu."
            </p>
            <div className="author-details align-center">Łukasz Gurazda, Właściciel</div>
            <div className="align-center margin-top-67 padding-bottom-20">
              <Link to="/o-nas" className="more">
                <span>poznaj nas bliżej</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div id="services" className="row full-width page-padding-top-section padding-bottom-66">
        <div className="row">
          <h2 className="box-header">Co możemy zrobić dla Twojego BMW?</h2>
          <p className="description align-center">
            Świadczymy bardzo szeroki zakres usług dla posiadaczy pojazdów marki BMW. Począwszy od okresowych
            przeglądów, <br /> wymiany opon i mechaniki, po zaawansowaną diagnostykę i naprawy powypadkowe.<br />
          </p>
          <ul className="services-list clearfix page-margin-top">
            {edges.map(({ node }) => (
              <li key={node.name}>
                <Link to={node.slug} title={node.name}>
                  <Img
                    sizes={data[node.image1].sizes}
                    imgStyle={{ objectPosition: '0 0' }}
                    style={{ width: '100%', maxHeight: '246.92px' }}
                  />
                  <h4 className="box-header">
                    {node.name}
                    <span className="template-arrow-menu" />
                  </h4>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="row page-padding-top-section gray full-width padding-bottom-66">
        <div className="row ">
          <h2 className="box-header">co mówią o nas klienci?</h2>
          <p className="description align-center">
            Cieszymy się wspaniałą reputacją również w sieci.<br />
            Zobacz jakie oceny dają nam nasi klienci.
          </p>
          <div className="row page-margin-top">
            <div className="column column-1-3">
              <ul className="features-list big">
                <li className="reference">
                  <Img
                    className="logo-image"
                    sizes={data.google_logo.sizes}
                    imgStyle={{ objectPosition: '0 0' }}
                    style={{ width: '100%' }}
                  />
                  <div className="star-wrapper">
                    <span className="star star--5" />
                  </div>
                  <h4 className="box-header page-margin-top">Ocena 4.9</h4>
                  <a
                    href="https://www.google.pl/search?ei=ZlfYWuOILonQwQK_toq4AQ&q=bmw+luk+%26+luk&oq=bmw+luk+%26+luk&gs_l=psy-ab.3...2733.5090.0.5229.0.0.0.0.0.0.0.0..0.0....0...1c.1.64.psy-ab..0.0.0....0.9q5dipymxFQ#lrd=0x4711682863078b67:0x9309d697c835aca3,1,,,"
                    className="more"
                    target="_blank"
                  >
                    <span>zobacz opinie</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="column column-1-3">
              <ul className="features-list big">
                <li className="reference">
                  <Img
                    className="logo-image"
                    sizes={data.moto_logo.sizes}
                    imgStyle={{ objectPosition: '0 0' }}
                    style={{ width: '100%' }}
                  />
                  <div className="star-wrapper">
                    <span className="star star--5" />
                  </div>
                  <h4 className="box-header ">Ocena 5.0</h4>
                  <a
                    href="https://motointegrator.com/pl/pl/warsztat/raciborz/lvq9wob-luk-luk-auto-serwis-s-c"
                    className="more"
                    target="_blank"
                  >
                    <span>zobacz opinie</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="column column-1-3">
              <ul className="features-list big">
                <li className="reference">
                  <Img
                    className="logo-image"
                    sizes={data.facebook_logo.sizes}
                    imgStyle={{ objectPosition: '0 0' }}
                    style={{ width: '100%' }}
                  />
                  <div className="star-wrapper">
                    <span className="star star--5" />
                  </div>
                  <h4 className="box-header page-margin-top">Ocena 5.0</h4>
                  <a
                    href="https://www.facebook.com/pg/LUK-LUK-Auto-Serwis-Niezale%C5%BCny-Serwis-BMW-Racib%C3%B3rz-668943926599017/reviews/"
                    className="more"
                    target="_blank"
                  >
                    <span>zobacz opinie</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div style={{ position: 'relative' }} className="row full-width padding-top-70 padding-bottom-66 parallax">
        <Img
          sizes={data.testimonialsBackground.sizes}
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
          }}
        />
        <div className="row testimonials-container">
          <ul className="testimonials-list">
            <Slider />
          </ul>
        </div>
      </div>

      <div className="row full-width page-padding-top-section">
        <div className="row">
          <h2 className="box-header">nasze certyfikaty</h2>
          <div className="hexagon">
            <div className="sl-small-car-checklist align-center" />
          </div>
          <p className="description align-center">
            Zapoznaj się z dziesiątkami certyfikatów potwierdzających wysokie standardy naszych usług.
          </p>
          <div className="align-center margin-top-40 padding-bottom-66">
            <Link to="/certyfikaty" className="more">
              <span>zobacz certyfikaty</span>
            </Link>
          </div>
        </div>
      </div>

      <div className="row gray full-width page-margin-top-section">
        <div className="announcement clearfix">
          <ul className="columns no-width">
            <li className="column column-2-3">
              <div className="vertical-align">
                <div className="vertical-align-cell">
                  <h3>Umów się na wizytę</h3>
                </div>
              </div>
            </li>
            <li className="column column-1-3">
              <div className="vertical-align">
                <div className="vertical-align-cell">
                  <Link to="/kontakt" className="more">
                    <span>zarezerwuj wizytę</span>
                  </Link>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  query HomePage {
    allServicesDataJson {
      edges {
        node {
          name
          image1
          slug
        }
      }
    }

    hero_background: imageSharp(id: { regex: "/hero_background/" }) {
      sizes(maxWidth: 1920, maxHeight: 868) {
        ...GatsbyImageSharpSizes
      }
    }
    bossImage: imageSharp(id: { regex: "/bossImage/" }) {
      sizes(maxHeight: 750) {
        ...GatsbyImageSharpSizes
      }
    }
    service_1: imageSharp(id: { regex: "/service_22/" }) {
      sizes(maxWidth: 400, maxHeight: 270) {
        ...GatsbyImageSharpSizes
      }
    }

    service_3: imageSharp(id: { regex: "/service_3/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_5: imageSharp(id: { regex: "/service_5/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_7: imageSharp(id: { regex: "/service_7/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_9: imageSharp(id: { regex: "/service_9/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_11: imageSharp(id: { regex: "/service_11/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_14: imageSharp(id: { regex: "/service_14/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    testimonialsBackground: imageSharp(id: { regex: "/testimonials/" }) {
      sizes(maxWidth: 1920) {
        ...GatsbyImageSharpSizes
      }
    }
    facebook_logo: imageSharp(id: { regex: "/facebook_logo/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    google_logo: imageSharp(id: { regex: "/google_logo/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    moto_logo: imageSharp(id: { regex: "/moto_logo/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;
export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js